import type { FormatRelativeTime } from "./types";

const MINUTE = 60_000;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;
const WEEK = 7 * DAY;

export const formatRelativeTime: FormatRelativeTime = ({
  isoDate,
  now,
  locale,
}) => {
  const date = new Date(isoDate);
  const elapsed = now.getTime() - date.getTime();
  // Older than a week reads better as a date than as "9 days ago".
  if (elapsed >= WEEK) return date.toLocaleDateString(locale);

  const relative = new Intl.RelativeTimeFormat(locale, { numeric: "auto" });
  if (elapsed < MINUTE) return relative.format(0, "second");
  if (elapsed < HOUR)
    return relative.format(-Math.floor(elapsed / MINUTE), "minute");
  if (elapsed < DAY)
    return relative.format(-Math.floor(elapsed / HOUR), "hour");
  return relative.format(-Math.floor(elapsed / DAY), "day");
};
